import styled from "@emotion/styled";

import FlexContainer from "shared/components/FlexContainer";

export const PropertyIntegrationMarkContainer = styled(FlexContainer)<{
  opacity?: number;
}>`
  opacity: ${({ opacity }) => opacity ?? 1};
`;
